import React, {useEffect, useState} from 'react';
import {connect, useSelector} from 'react-redux';
//import { Button, Form, Alert } from "react-bootstrap";
//import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
//import Card from 'react-bootstrap/Card';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from '@material-ui/core/Paper';
import Card from '@material-ui/core/Card';
import Typography from '@mui/material/Typography';
import CardContent from '@material-ui/core/CardContent';
//import CardHeader from '@material-ui/core/CardHeader';
import CardHeader from '@mui/material/CardHeader';
import CardActions from '@material-ui/core/CardActions';
import Divider from '@material-ui/core/Divider';
import { Redirect } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner'
import { makeStyles } from '@material-ui/core/styles';
import * as actions from "../store/actions";
import * as actionTypes from "../store/actions/actionTypes";
import SuperResellerClientTransactions from './SuperResellerClientTransactions';
import ResellerPassword from './ResellerPassword';
import TotalsChartByName from './TotalsChartByName';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    header: {
        //textAlign: 'center',
        spacing: 2
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,

    },
    input: {
        borderRadius: 4,
        position: 'relative',
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 5px 10px 5px',
        margin: theme.spacing(1),
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:focus': {
            borderRadius: 4,
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));


function UpdateReseller(props){

    const [reseller, setReseller] = useState(
        props.currentReseller
    );
    const [transaction, setTransaction] = useState(0);

    const [credits, setCredits] = useState(1);
    //const currentDescription = useSelector((state) => state.reseller.item.description);
    const [description, setDescription] = useState("");
    //const [superReseller, setSuperReseller] = useState(0);
    //const [superResellersList, setSuperResellersList] = useState([]);
    const resellerSelector = useSelector((state) => state.reseller.name);
    const paperStyle = {padding: 16};

    const classes = useStyles();

    useEffect(() => {
        //props.onInitializeSaveClient();
        props.onInitializeSaveReseller();
        props.onGetReseller(props.token, props.currentResellerName);
        console.log('logging description', description);

    }, []);

    //useEffect(() => {
    //    if (props.superResellers && props.superResellers.length){
    //        setSuperResellersList(props.superResellers);
    //        setSuperReseller(props.currentSuperResellerName);
    //    }
    //},[]);

    useEffect(() => {
        console.log('inside useEffect currentreseller state change', props.currentReseller);
        //console.log('useEffect currentreseller length', props.currentReseller.length);
        //if (props.currentReseller && props.currentReseller.length){
        setReseller(props.currentReseller);
        console.log('current reseller object', reseller);
        setDescription(props.currentReseller.description);
        console.log('logging description', description);
        //}
    }, [props.currentReseller]);

    useEffect(() => {
        if (props.isErrorSaveReseller){
            var errorMessage = '' + props.isErrorSaveReseller;
            props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_ERROR, message: errorMessage});
        }
    }, [props.isErrorSaveReseller]);

    const handleChange = (event) => {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        console.log('name', name);
        console.log('value', value);
        const key = target.key;
        setReseller({
            ...reseller,
            [name]: value
        })
    };

    const spinner = (
        <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
        />
    );

    let options = [...Array(100).keys()].slice(1);
    options = [...options, 100, 200, 300, 400, 500, 600, 700, 800, 900, 1000];

    function handleSubmitCredits(event) {
        event.preventDefault();

        const data = {
            name: reseller.name,
            credits: credits,
            transaction: transaction,
            desc: description

        };
        console.log('logging data', data);
        props.onSaveReseller(props.token, data);

    }

    //function handleEditReseller(event) {
    //    event.preventDefault();

    //    const data = {
    //        name: props.currentReseller.name,
    //        //superReseller: superReseller,
    //        description: description
    //    };
     //   console.log('logging data', data);
        //if (superReseller === 0){
        //    var errorMessage = 'Please select a super reseller';
        //    props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_ERROR, message: errorMessage});
        //} else {
    //        props.onUpdateResellerAdmin(props.token, data);
        //}
    //}

    let saveResellerRedirect = null;
    if(props.isSuccessSaveReseller){
        console.log('redirecting because', props.isSuccessSaveReseller);
        props.onGetCredits(props.token);
        var successMessage = 'Updated ' + props.isSuccessSaveReseller.name;
        props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_SUCCESS, message: successMessage});
        saveResellerRedirect = <Redirect to="/resellers" />
    }

    // let displayError = null;
    // if (props.isErrorSaveReseller){
    //     //displayError = <Alert variant="danger">{props.isErrorSaveReseller}</Alert>
    //     var errorMessage = '' + props.isErrorSaveReseller;
    //     props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_ERROR, message: errorMessage});
    // }

    //<FormGroup>
    //    <FormControl className={classes.formControl}>
    //        <TextField
    //            id="description"
    //            name="description"
    //            value={reseller.description}
    //            label="Description"
    //            onChange={handleChange}
    //            type="text"
    //        />
    //    </FormControl>
    //</FormGroup>
    //
    ////onChange={e => setDescription(e.target.value)}
    return (
        <div>
            {saveResellerRedirect}
            <Container>
                <Grid container spacing={2}>
                    <Grid item sm={12}>
                    </Grid>
                    <Grid item sm={12} xs={12}>
                        <Grid container spacing={2}>
                            <Grid item sm={4} xs={12}>
                                <Paper elevation={5}>
                                    <Card>
                                        <CardHeader
                                            title="Edit Reseller"
                                            subheader={props.currentReseller.name + ', ' + props.currentReseller.credits + ' Credits'}
                                            titleTypographyProps={{
                                                fontSize: 17,
                                                fontWeight: 'bold'
                                            }}
                                            subheaderTypographyProps={{
                                                fontSize: 14,
                                            }}
                                        />
                                        <Divider variant="middle" />
                                        <CardContent>
                                            <form>
                                                <FormGroup row>
                                                    <FormControl fullWidth>
                                                        <InputLabel id="select-transactions-label">Select Transaction</InputLabel>
                                                        <Select
                                                            id="transaction"
                                                            labelId="Transaction"
                                                            onChange={e => setTransaction(e.target.value)}
                                                            value={transaction}
                                                        >
                                                            <MenuItem key={0} value={0}>Add</MenuItem>
                                                            <MenuItem key={0} value={1}>Remove</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </FormGroup>
                                                <FormGroup row>
                                                <FormControl fullWidth>
                                                    <InputLabel id="select-credits-label">Credits</InputLabel>
                                                    <Select
                                                        id="credits"
                                                        labelId="Credits"
                                                        onChange={e => setCredits(e.target.value)}
                                                        value={credits}
                                                    >
                                                        {options.map(option => {
                                                            return <MenuItem key={option} value={option}>{option}</MenuItem>
                                                        })}
                                                    </Select>
                                                </FormControl>
                                                </FormGroup>
                                                <FormGroup row>
                                                    <FormControl className={classes.formControl} fullWidth>
                                                        <TextField
                                                            id="description"
                                                            name="description"
                                                            value={description}
                                                            label="Description"
                                                            onChange={e => setDescription(e.target.value)}
                                                            type="text"
                                                        />
                                                    </FormControl>
                                                </FormGroup>
                                            </form>
                                        </CardContent>
                                        <CardActions>
                                            <Button
                                                block
                                                disabled={props.isLoadingSaveReseller}
                                                type="submit"
                                                onClick={handleSubmitCredits}
                                                variant="contained"
                                                color="primary"
                                                size="small"
                                                fullWidth
                                            >
                                                {props.isLoadingSaveReseller
                                                    ? spinner
                                                    : 'Submit'}
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Paper>
                            </Grid>
                            <Grid item sm={4} xs={12} mb={5}>
                                <Paper elevation={5}>
                                    <ResellerPassword />
                                </Paper>
                            </Grid>

                        </Grid>
                    </Grid>
                    <Grid item sm={12} xs={12}>
                        <Grid container spacing={2}>
                            <Grid item sm={12} xs={12} mb={5}>
                                <Paper elevation={5}>
                                    <Card>
                                        <CardHeader
                                            title="Transaction History"
                                            titleTypographyProps={{
                                                fontSize: 17,
                                                fontWeight: 'bold'
                                            }}
                                        />
                                        <Divider variant="middle" />
                                        <CardContent><SuperResellerClientTransactions /></CardContent>
                                    </Card>
                                </Paper>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item sm={12} xs={12}>
                        <Paper elevation={5}>
                            <TotalsChartByName role="manager" name={resellerSelector} />                        
                        </Paper>                           
                    </Grid>
                </Grid>
            </Container>
        </div>
    )

}

const mapDispatchToProps = dispatch => {
    return {
        onGetReseller: (token, name) => dispatch(actions.getReseller(token, name)),
        onInitializeSaveReseller: () => dispatch(actions.initializeSaveReseller()),
        onSaveReseller: (token, data) => dispatch(actions.saveReseller(token, data)),
        onUpdateResellerCredits: (token, data) => dispatch(actions.updateResellerCreditsAdmin(token, data)),
        //onUpdateResellerAdmin: (token, data) => dispatch(actions.updateResellerAdmin(token, data)),
        onGetCredits: (token) => dispatch(actions.creditsSuperReseller(token)),
        onDisplaySnackbar: (message) => dispatch(actions.showSuccessSnackbar(message))
    }
};

const mapStateToProps = state => {
    return {
        token: state.auth.token,
        currentResellerName: state.reseller.name,
        currentSuperResellerName: state.superReseller.name,
        currentReseller: state.reseller.item,
        isLoadingReseller: state.reseller.loading,
        isErrorSaveReseller: state.saveReseller.error,
        isSuccessSaveReseller: state.saveReseller.reseller,
        isLoadingSaveReseller: state.saveReseller.loading,
        //superResellers: state.superResellers.super_reseller_list

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateReseller);